export const tasks = {
  // Oldal címek
  title: 'Feladatok',
  subtitle: 'Feladatok kezelése és nyomon követése',
  create: 'Új feladat',
  createTask: 'Új feladat létrehozása',
  edit: 'Feladat szerkesztése',
  editTask: 'Feladat szerkesztése',
  delete: 'Feladat törlése',

  // Szekciók
  sections: {
    basicInfo: 'Alapadatok',
    description: 'Leírás',
    assignment: 'Hozzárendelés',
    timeEstimation: 'Időbecslés',
    timeEstimate: 'Időbecslés',
    tags: 'Címkék',
    timeCompletion: 'Időzítés és befejezés',
    assignmentClient: 'Hozzárendelés és ügyfél',
    tagsWork: 'Címkék és munka',
    comments: 'Megjegyzések'
  },

  // Mezők
  fields: {
    taskNumber: 'Feladat szám',
    title: 'Feladat neve',
    description: 'Leírás',
    priority: 'Prioritás',
    status: 'Státusz',
    assignedTo: 'Felelős',
    customer: 'Ügyfél',
    project: 'Projekt',
    dueDate: 'Határidő (dátum és idő)',
    completedDate: 'Befejezés dátuma',
    estimatedHours: 'Becsült órák',
    actualHours: 'Tényleges órák',
    tags: 'Címkék',
    documents: 'Dokumentumok',
    createdAt: 'Létrehozva',
    updatedAt: 'Frissítve',
    createdBy: 'Létrehozó'
  },

  // Prioritások
  priority: {
    low: 'Alacsony',
    medium: 'Közepes',
    high: 'Magas',
    urgent: 'Sürgős'
  },

  // Státuszok
  status: {
    todo: 'Tennivaló',
    in_progress: 'Folyamatban',
    completed: 'Befejezett',
    cancelled: 'Megszakított'
  },

  // Placeholder szövegek
  placeholders: {
    taskTitle: 'Adja meg a feladat nevét',
    taskDescription: 'Feladat részletes leírása...',
    assignedTo: 'Felelős neve vagy email címe',
    selectCustomer: 'Válasszon ügyfelet...',
    selectProject: 'Válasszon projektet...',
    selectAssignee: 'Válasszon felelőst...',
    searchCustomer: 'Keresés ügyfelek között...',
    searchProject: 'Keresés projektek között...',
    searchAssignee: 'Keresés felhasználók között...',
    noCustomersFound: 'Nem található ügyfél',
    noProjectsFound: 'Nem található projekt',
    noAssigneesFound: 'Nem található felhasználó',
    addTag: 'Új címke hozzáadása...',
    documents: 'Csatolja a feladathoz kapcsolódó dokumentumokat',
    searchTasks: 'Keresés feladatok között...',
    searchPlaceholder: 'Keresés...',
    noResults: 'Nincs találat'
  },

  // Műveletek
  actions: {
    newTask: 'Új feladat',
    createFirstTask: 'Első feladat létrehozása',
    addTag: 'Hozzáadás',
    viewTask: 'Megtekintés',
    viewComments: 'Megjegyzések',
    editTask: 'Szerkesztés',
    deleteTask: 'Törlés',
    assignToMe: 'Hozzárendelés magamhoz',
    unassign: 'Hozzárendelés törlése',
    markCompleted: 'Befejezettnek jelölés',
    markInProgress: 'Folyamatban jelölés',
    export: 'Export szövegként'
  },

  // Szűrők
  filters: {
    all: 'Összes',
    dueToday: 'Ma esedékes',
    dueThisWeek: 'Ezen a héten esedékes',
    overdue: 'Lejárt'
  },

  // Statisztikák
  stats: {
    totalTasks: 'Összes feladat',
    todoTasks: 'Tennivalók',
    inProgressTasks: 'Folyamatban',
    completedTasks: 'Befejezett',
    overdueTasks: 'Lejárt',
    myTasks: 'Saját feladatok',
    completionRate: 'Befejezési arány'
  },

  // Üzenetek
  messages: {
    loadingTasks: 'Feladatok betöltése...',
    noTasks: 'Még nincsenek feladatok',
    noTasksInProject: 'Nincsenek feladatok ebben a projektben',
    noTasksFound: 'Nem található feladat',
    createSuccess: 'Feladat sikeresen létrehozva!',
    createError: 'Hiba történt a feladat létrehozása során',
    updateSuccess: 'Feladat sikeresen frissítve!',
    updateError: 'Hiba történt a feladat frissítése során',
    deleteSuccess: 'Feladat sikeresen törölve!',
    deleteError: 'Hiba történt a feladat törlése során',
    assignSuccess: 'Feladat sikeresen hozzárendelve!',
    assignError: 'Hiba történt a feladat hozzárendelése során',
    unassignSuccess: 'Hozzárendelés sikeresen törölve!',
    statusUpdateSuccess: 'Státusz sikeresen frissítve!',
    statusUpdateError: 'Hiba történt a státusz frissítése során',
    priorityUpdateSuccess: 'Prioritás sikeresen frissítve!',
    priorityUpdateError: 'Hiba történt a prioritás frissítése során',
    confirmDelete: 'Biztosan törölni szeretné ezt a feladatot?',
    overdue: 'Lejárt',
    dueToday: 'Ma esedékes',
    dueSoon: 'Hamarosan lejár',
    dueInDays: '{{days}} nap múlva jár le',
    exportSuccess: 'Feladat sikeresen exportálva!'
  },

  // Kommentek
  comments: {
    empty: 'Még nincsenek megjegyzések',
    emptyHint: 'Adj hozzá megjegyzéseket',
    placeholder: 'Írj megjegyzést...',
    hint: 'Tipp: Használd a megjegyzéseket tesztelési eredmények rögzítésére',
    send: 'Küldés',
    sending: 'Küldés...',
    delete: 'Törlés',
    deleteConfirm: 'Biztosan törölni szeretnéd ezt a megjegyzést?',
    addSuccess: 'Megjegyzés hozzáadva',
    addError: 'Hiba a megjegyzés hozzáadásakor',
    deleteSuccess: 'Megjegyzés törölve',
    deleteError: 'Hiba a megjegyzés törlésekor',
    emptyMessage: 'A megjegyzés nem lehet üres',
    edit: 'Szerkesztés',
    editSuccess: 'Megjegyzés frissítve',
    editError: 'Hiba a megjegyzés frissítésekor'
  },

  // Validációs üzenetek
  validation: {
    titleRequired: 'A feladat neve kötelező',
    estimatedHoursMin: 'A becsült órák száma nem lehet negatív',
    actualHoursMin: 'A tényleges órák száma nem lehet negatív'
  }
}; 